import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    d: "M21.92 11.6241a1 1 0 0 0-.21-.33l-5-5A1.003 1.003 0 0 0 16 6a1.0041 1.0041 0 0 0-.71 1.714l3.3 3.2901H4a.9997.9997 0 0 0-1 1 1 1 0 0 0 1 1h14.59l-3.3 3.29a.9997.9997 0 0 0 0 1.42.9997.9997 0 0 0 1.42 0l5-5a1 1 0 0 0 .21-.33c.1-.2435.1-.5165 0-.76"
}), "ArrowRightLong", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
